import {ElementType } from "../dom-tools/ElementType";

export class JSONHTMLTree
{
  rootType = new ElementType<HTMLElement>( "json--root" );

  memberType = new ElementType<HTMLElement>( "json--member" );
  nameType = new ElementType<HTMLElement>( "json--name" );
  valueType = new ElementType<HTMLElement>( "json--value" );
  dataType = new ElementType<HTMLElement>( "json--data" );

  nameToken = "XXXX";
  nameTemplate = "[ XXXX ]:";
  beautyNames = true;

  _root:HTMLElement;

  static createFrom( obj:any )
  {
    let tree = new JSONHTMLTree();
    return tree.create( obj ) ;
  }

  create( obj:any )
  {
    this._root = this.rootType.create();
    this._createValue( obj, this._root );

    return this._root;
  }
 

  private _createValue( value:any, parent:Element )
  {
    
    if ( 
      value == null ||
      typeof( value ) === "string" || 
      typeof( value ) === "number" ||
      typeof( value ) === "boolean" 
    )
    {
      parent.appendChild( this.dataType.create( value + "" ) );
      return;
    }
    else if ( Array.isArray( value ) )
    {
      this._createArray( value, parent );
    }
    else
    {
      this._createObject( value, parent );
    }
  } 

  private _beautifyName( value:string )
  {
    let bName = value[ 0 ].toUpperCase();


    for ( let i = 1; i < value.length; i++ )
    {
      let char = value[ i ];

      if ( char.toLowerCase() != char )
      {
        bName += " " + char;
      }
      else
      {
        bName += char;
      }
    }

    return bName;

  }

  private _createObject( obj:any, parent:Element )
  {
    for ( let it in obj )
    {
      if ( ! obj.hasOwnProperty( it ) )
      {
        continue;
      }

      let memberValue = this.valueType.create();
      let name = it;
      
      if ( this.beautyNames )
      {
        name =  this._beautifyName( name );
      }

      let nameValue = this.nameTemplate.replace( this.nameToken, name );

      let entry = this.memberType.create(
        [
          this.nameType.create( nameValue ),
          memberValue
        ]
      );

      this._createValue( obj[ it ], memberValue );

      parent.appendChild( entry );
    }
  }

  private _createArray( obj:any, parent:Element )
  {
    let arr = obj as Array<any>;

    for ( let i = 0; i < arr.length; i++ )
    {
      let memberValue = this.valueType.create();

      let entry = this.memberType.create(
        [
          this.nameType.create( i + "" ),
          memberValue
        ]
      );

      this._createValue( obj[ i ], memberValue );

      parent.appendChild( entry );
    }
  }
}